"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/chart.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M40.16 41.833H1.84c-.464 0-.86-.162-1.185-.487a1.612 1.612 0 01-.488-1.185V1.84c0-.465.162-.86.488-1.185C.98.33 1.375.167 1.84.167c.465 0 .86.162 1.186.487.325.326.488.72.488 1.185v36.65h36.644c.465 0 .86.162 1.186.488.326.325.488.72.488 1.184 0 .465-.162.86-.488 1.185-.325.325-.72.487-1.186.487zM15.32 33.5c-.585 0-1.046-.262-1.385-.785l-7.25-12.272a1.892 1.892 0 01-.232-1.35c.093-.474.331-.842.716-1.104.385-.262.8-.344 1.247-.246.447.099.793.344 1.04.737l5.172 8.933 2.124-8.688c.123-.523.416-.9.877-1.129l8.405-4.32c.4-.196.8-.237 1.201-.122.4.114.724.368.97.76l4.202 7.265 6.189-19.781c.154-.458.43-.802.831-1.03.4-.23.816-.263 1.247-.1.431.165.754.46.97.884.215.426.246.868.092 1.326L34.44 25.892c-.215.72-.677 1.12-1.385 1.202-.708.082-1.247-.188-1.616-.81l-5.311-9.13-6.327 3.24-2.863 11.78c-.185.753-.631 1.179-1.34 1.277a.825.825 0 01-.277.049z",
    fill: "#687687",
    fillRule: "evenodd",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;